module.exports = dataLayer;


//////////////////
// WEBPACK FOOTER
// external "dataLayer"
// module id = 193
// module chunks = 0